import { APP_DOMAIN } from 'utils/urls';

const MEDIA_HOST = `https://media.${APP_DOMAIN}`;

const ABSOLUTE_URL_PATTERN = /^https?:\/\//i;
const MEDIA_HOST_PATTERN = /^https?:\/\/media\.[^/]+\/?/i;

export const getMediaBase = (): string => MEDIA_HOST;

export const getMediaUrl = (path: string): string => {
  if (!path) return '';

  if (ABSOLUTE_URL_PATTERN.test(path)) {
    return path.replace(MEDIA_HOST_PATTERN, `${MEDIA_HOST}/`);
  }

  const normalized = path.replace(/^\/+/, '');
  return `${MEDIA_HOST}/${normalized}`;
};

export const getAvatarUrl = (avatar: string): string => getMediaUrl(`images/${avatar}`);

export const getLobbyAssetUrl = (filename: string): string =>
  getMediaUrl(`images/lobby/${filename}`);

// The media host serves images with `Cache-Control: no-store`, so the HTTP
// cache never holds them. Within a page, the browser only reuses an image
// while something still references it; once every <img> using it unmounts and
// the image is garbage-collected, the next mount downloads it again. Holding
// one Image per URL here pins it for the life of the page. That live reference
// also keeps the download alive when the lobby unmounts mid-fetch — without
// it, iOS WebKit cancelled the load and every tile painted the same truncated
// art until a reload (EN-11042).
const retainedImages = new Map<string, HTMLImageElement>();

export const retainImage = (url: string): void => {
  if (!url || retainedImages.has(url)) return;

  const img = new Image();
  // Release a failed load so the next retain retries instead of holding a dead
  // entry for the rest of the page.
  img.onerror = () => retainedImages.delete(url);
  img.src = url;
  retainedImages.set(url, img);
};
